export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-bold-web-cc689f79be83d5803c9f7f620a23ec73.woff";